import React from 'react'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import * as Style from './style'

const ModernDrawer = ({
	open = false,
	onClose,
	direction = 'right',
	size = 400,
	title = '',
	children,
	footer,
	showCloseButton = true,
	duration = 300,
	overlayOpacity = 0.4,
	overlayColor = '#000',
	enableOverlay = true,
	lockBackgroundScroll = true,
	zIndex = 1000,
	className = '',
	style = {},
	...props
}) => {
	return (
		<Drawer
			open={open}
			onClose={onClose}
			direction={direction}
			size={size}
			duration={duration}
			overlayOpacity={overlayOpacity}
			overlayColor={overlayColor}
			enableOverlay={enableOverlay}
			lockBackgroundScroll={lockBackgroundScroll}
			zIndex={zIndex}
			className={className}
			style={style}
			{...props}
		>
			<Style.DrawerContent>
				{(title || showCloseButton) && (
					<Style.DrawerHeader>
						{title && <Style.DrawerTitle>{title}</Style.DrawerTitle>}
						{showCloseButton && (
							<Style.CloseButton onClick={onClose} type='button'>
								×
							</Style.CloseButton>
						)}
					</Style.DrawerHeader>
				)}

				<Style.DrawerBody>{children}</Style.DrawerBody>

				{footer && <Style.DrawerFooter>{footer}</Style.DrawerFooter>}
			</Style.DrawerContent>
		</Drawer>
	)
}

export default ModernDrawer
